import { convertToHandle } from '~/helpers/convert'

/**
 * Store: Bracelet finder store store
 * -----------------------------------------------------------------------------
 * Store to hold bracelet finder state and step selections.
 */
export default {
  namespaced: true,

  state: () => ({
    chosenMetal: '',
    chosenWidth: '',
    chosenProductId: '',
    braceletEntries: [],
  }),

  mutations: {

    SET_METAL(state, metal) {
      state.chosenMetal = metal
    },

    SET_WIDTH(state, width) {
      const handleizedWidth = width?.replace(/[. ]/g, '-').toLowerCase()
      state.chosenWidth = handleizedWidth
    },

    SET_PRODUCT_ID(state, pid) {
      state.chosenProductId = pid
    },

    SET_BRACELET_ENTRIES(state, braceletEntries) {
      state.braceletEntries = braceletEntries
    },
  },

  actions: {

    /**
     * Set the chosen metal from step 1
     * @param {string} metal - Metal name such as Gold, Rose Gold
     */
    setMetal({ commit }, metal) {
      commit('SET_METAL', metal)
    },

    /**
     * Set the chosen width from step 2
     * @param {string} width - Width name such as 5mm or 7-5mm
     */
    setWidth({ commit }, width) {
      commit('SET_WIDTH', width)
    },

    /**
     * Set the selected product id from step 2
     * @param {number} pid - Product ID
     */
    setProductId({ commit }, pid) {
      commit('SET_PRODUCT_ID', pid)
    },

    /**
     * The entries in bracelet_finder metaobject
     * @param {Array} entries
     */
    setBraceletEntries({ commit }, entries) {
      commit('SET_BRACELET_ENTRIES', entries)
    },
  },

  getters: {

    getDataByMetal(state) {
      return state.braceletEntries.find((entry) => entry.label === state.chosenMetal) || {
        products: {
          gauge_product_list: [],
        },
        label: '',
        image: false,
        step2: {
          products: [],
          images: [],
          altImages: [],
        },
      }
    },

    getSiblings(state, getters) {
      return {
        label: '',
        products: getters.getDataByMetal.products[state.chosenWidth] || [],
        grid: true,
      }
    },

    /**
     * Get step 2 products with product id, image, and label
     * @returns {array}
     */
    getGaugeProducts(_, getters) {
      const data = getters.getDataByMetal.step2

      return data.products.map((product, index) => {
        const label = product.metafields.find(
          (metafield) => metafield?.key === 'gauge',
        )?.value?.value

        return {
          pid: product.id,
          image: data.images[index] || product.featuredImage,
          label,
        }
      })
    },
  },
}
